import { Injectable } from '@angular/core';

@Injectable()
export class IdGeneratorService {
  generateId(elementKey: string) {
    return `${elementKey}-${Math.random()
      .toString(36)
      .substring(2, 9)}`;
  }
}
